import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 3FC392DC-44A8-475E-8082-7DBF80A61519
 * name store-settings-outline
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-settings-outline.svg
 * tags
 * - Places 
 * - Shopping 
 * - Settings 
 */
export const StoreSettingsOutlineIcon = createSvgIcon(<><path d="M20 6H4V4H20V6M21 12V14H20V20H18V14H14V20H4V14H3V12L4 7H20L21 12M12 14H6V18H12V14M18.96 12L18.36 9H5.64L5.04 12H18.96M7 24H9V22H7V24M11 24H13V22H11V24M15 24H17V22H15V24Z" /></>, 'StoreSettingsOutlineIcon');
export default StoreSettingsOutlineIcon